import { Spinner } from "@fluentui/react-components";
import { E_SIZE, ILoadingProps } from "./Models";
import { LoadingPanelWrapper, LoadingSpinnerWrapper } from "./Styles";

const LoadingCustom = (props: ILoadingProps) => {
  return (
    <LoadingPanelWrapper
      className="LoadingPanelWrapper loading-panel ms-Overlay"
    >
      <LoadingSpinnerWrapper className="LoadingSpinnerWrapper">
        <Spinner size={props.size || E_SIZE.medium} />
      </LoadingSpinnerWrapper>
    </LoadingPanelWrapper>
  );
};

export default LoadingCustom;
